<template>
  <!--用户管理-普通用户-->
  <div class="content userManagement">
    <div class="layui-fluid">
      <div class="layui-row">
        <div class="layui-col-md12">
          <!--面包屑-->
          <div class="layui-row">
            <div class="layui-col-md8">
              <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '' }">用户管理</el-breadcrumb-item>
                <el-breadcrumb-item>普通用户</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
          </div>
          <div class="layui-row" style="margin-top: 20px;">
            <div class="layui-col-md12">
              <form class="layui-form" action>
                <div class="layui-form-item">
                  <el-button  @click="free" type="primary">新建免费用户</el-button>
                </div>
              </form>
            </div>
          </div>
          <div class="layui-row">
            <div class="layui-col-md12">
              <table class="layui-hide" id="test" lay-filter="test"></table>
              <script type="text/html" id="barDemo">
  <!-- <a class="layui-btn layui-btn-xs" lay-event="edit" style="color: #FFFFFF;">编辑</a> -->
  <a class="layui-btn layui-btn-danger layui-btn-xs" lay-event="del" style="color: #FFFFFF;">删除</a>
              </script>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserManagement",
  data() {
    return {
      msg: "",
    };
  },
  methods: {
    /* 监听详情，删除 */
    xiang() {
      let _this = this;
      layui.use(["jquery", "element", "table", "layer"], function () {
        var $ = layui.jquery;
        var element = layui.element;
        var table = layui.table;
        /* 监听查看详情*/
        table.on("tool(test)", function (obj) {
          var data = obj.data;
          console.log(obj);
          if (obj.event === "edit") {
             _this.$router.push({
                name: "Free",
                params: {
                  id:data.id                
                }})
          } else if (obj.event === "del") {
            layer.confirm("确定删除此行么", function (index) {
              let url = "/ac1/conference/modifyFreeUser";
              var params = {
                id: data.id,
                status: -1,
              };
              _this.$delet(url, params).then((res) => {
                if (res.code == 1) {
                  obj.del(); //删除对应行（tr）的DOM结构，并更新缓存
                  layer.close(index);
                 _this.$message({
          message: '删除成功',
          type: 'success',
          duration:1000
        });
                  let url = "/ac1/conference/freeUserList";
                  _this
                    .$get(url)
                    .then((res) => {
                      console.log(res);
                      if (res.code == "1") {
                        table.render({
                          elem: "#test",
                          data: res.posts,
                          cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
                          cols: [
                            [
                              { field: "id", title: "ID" },
                              { field: "name", title: "姓名" },
                              { field: "tel", title: "电话" },
                              { field: "conference_name", title: "所属会议" },
                              {
                                fixed: "right",
                                title: "操作",
                                toolbar: "#barDemo",
                                width: 140,
                              },
                            ],
                          ],
                          page: true,
                        });
                      } else {
                        console.log(res.msg);
                      }
                    })
                    .catch((error) => {
                      console.log(error);
                    });
                }
              });
            });
          }
        });
      });
    },
    free() {
      var _this = this;
      _this.$router.push("/Guest/Free");
    },
    // 公共方法
    handlePublics() {
      let _this = this;
      this.$nextTick(() => {
        layui.use(["jquery", "element", "form", "table"], function () {
          var $ = layui.jquery;
          var element = layui.element;
          var form = layui.form;
          var table = layui.table;
          /*---------报名管理开始---------*/
          let url = "/ac1/conference/freeUserList";
          _this.$get(url).then((res) => {
            console.log(res);
            if (res.code == 1) {
              table.render({
                elem: "#test",
                data: res.posts,
                // ,url:'/demo/table/user/'
                cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
                cols: [
                  [
                    { field: "id", title: "ID" },
                    { field: "name", title: "姓名" },
                    { field: "tel", title: "电话" },
                    { field: "conference_name", title: "所属会议" },
                    {
                      fixed: "right",
                      title: "操作",
                      toolbar: "#barDemo",
                      width: 140,
                    },
                  ],
                ],
                page: true,
              });
            }
          });

          /*---------报名管理结束---------*/
          element.render();
          form.render();
          table.render();
        });
      });
    },
  },
  mounted() {
    // 公共方法
    this.handlePublics();
    this.xiang();
  },
  updated() {
    // 公共方法
    this.handlePublics();
  },
};
</script>

<style scoped>
.userManagement .layui-form-label {
  width: auto;
}
.userManagement .layui-input-block {
  margin-left: 90px;
}
.userManagement .right_btn {
  margin-top: -10px;
}
</style>
